import { Fragment, useContext, useState } from 'react';
import { menuRoutes } from '../../../router/menu';
import PickupGlobalMessagesList from './PickupGlobalMessagesList';
import { FiltersProvider } from '../../../components/providers/FiltersProvider';
import PageHeader from '../../../layout/shared/page-header';
import { Button } from 'rizzui';
import cn from '../../../utils/classNames';
import { PrivilegeContext } from '../../../components/priviledge/PriviledgeProvider';
import { PickupGlobalMessage } from '../../../type/entities/pickup-global-message-type';


const PickupGlobalMessagesWrapper = () => {

    // STATES

    const [isOpenFormDrawer, setIsOpenFormDrawer] = useState(false);
    const [messageSelected, setMessageSelected] = useState<PickupGlobalMessage | null>(null);
    const defaultFilters = {};

    const breadCrumb = [
        { name: 'Administración' },
        { name: 'Gestión de Mensajes' },
        { name: 'Mensajes Globales', href: menuRoutes.pickupsMessages.path },
    ];

    // HOOKS

    const { userCan } = useContext(PrivilegeContext);

    // RENDER


    return (
        <Fragment>
            <FiltersProvider defaultFilterFilters={defaultFilters} >
                <PageHeader title="Mensajes Globales" breadcrumb={breadCrumb}>
                    {
                        userCan('create', 'pickup_global_messages') &&
                        (
                            <Button
                                color="primary"
                                onClick={() => { 
                                    setIsOpenFormDrawer(true) 
                                    setMessageSelected(null)
                                }}
                                className={cn(['mt-4 md:mt-0'])}
                            >
                                Crear Mensaje
                            </Button>
                        )
                    }
                </PageHeader>
                <PickupGlobalMessagesList openFormDrawer={isOpenFormDrawer} setOpenFormDrawer={setIsOpenFormDrawer} messageSelected={messageSelected} setMessageSelected={setMessageSelected} />
            </FiltersProvider>
        </Fragment>
    );
};

export default PickupGlobalMessagesWrapper;